import { Component, ChangeDetectionStrategy, EventEmitter, OnInit, Output, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { requiredValidator } from '../../validators';
import { markAsTouched } from '../../utils';

export interface DirectDebitDetails {
  authorise: boolean;
  bsb: number;
  number: number;
  name: string;
}

@Component({
  selector: 'app-direct-debit-form',
  templateUrl: 'direct-debit-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectDebitFormComponent implements OnInit, OnChanges {
  form = new FormGroup({
    authorise: new FormControl(null, Validators.requiredTrue),
    bsb: new FormControl(null, [requiredValidator(), Validators.pattern(/^\d{3}-?\d{3}$/)]),
    number: new FormControl(null, [requiredValidator(), Validators.pattern(/^\d{6,10}$/)]),
    name: new FormControl(null, requiredValidator()),
  });

  @Input() submitted: boolean = false;
  @Output() onChange = new EventEmitter();

  ngOnInit() {
    this.form
      .valueChanges
      .pipe(filter(() => this.form.valid))
      .subscribe(value => {
        markAsTouched(this.form);
        this.onChange.emit(value)
      });
  }

  ngOnChanges() {
    if (this.submitted) {
      markAsTouched(this.form);
    }
  }

  get authorise() {
    return this.form.get('authorise');
  }

  get bsb() {
    return this.form.get('bsb');
  }

  get number() {
    return this.form.get('number');
  }

  get name() {
    return this.form.get('name');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/payments/direct-debit-form.component.ts